import { Component, OnInit, Renderer2 } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalContactUsComponent } from '../../home/modal-contact-us/modal-contact-us.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  scrollPosition:number;

  constructor(
    private renderer: Renderer2,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
    this.renderer.listen(window, 'scroll', ($event) => {
      this.scrollPosition = window.scrollY;
    });
  }

  backToTop(){
    window.scrollTo(0,0);
  }

  openModalContactUs() {
    this.bsModalRef = this.modalService.show(
      ModalContactUsComponent,
      Object.assign({}, {class: 'modal-contact-us'})
    );
  }

}
